import React from 'react';
import { motion, AnimatePresence, Variants, Transition } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface AnimatedLayoutProps {
  children: React.ReactNode;
}

const pageVariants: Variants = {
  initial: {
    opacity: 0.5,
    x: '100%',
    position: 'absolute',
  },
  in: {
    opacity: 1,
    position: 'initial',
    x: 0,
  },
  out: {
    opacity: 0,
    x: '-100%',
    position: 'absolute',
  },
};

const pageTransition: Transition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3,
};

export const AnimatedLayout: React.FC<AnimatedLayoutProps> = ({ children }) => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <motion.div
        key={location.pathname}
        initial="initial"
        transition={pageTransition}
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
